<template>
  <div class="bc_box">
    <img src="@/assets/img/login/l_hello.png" alt="" class="hello_img" />
    <p class="login_title">欢迎登录中文知识网</p>
    <van-form @submit="onSubmit" class="login_form">
      <van-field
        class="input_tel"
        v-model="phone"
        type="tel"
        clearable
        placeholder="请填写手机号"
        :rules="[{ required: true }]"
      >
        <span slot="left-icon" class="tel_code" v-if="isCode">+86</span>
      </van-field>
      <van-field
        v-if="isCode"
        class="input_code"
        v-model="code"
        type="number"
        placeholder="请填写验证码"
        maxlength="6"
        :rules="[{ required: true }]"
      >
        <span slot="right-icon" :class="['tel_code', keyFlag ? '' : 'fontColor' ]" @click="getCode">{{
          keyFlag ? "获取验证码" : num + "秒后重新获取"
        }}</span>
      </van-field>
      <van-field
        v-else
        class="input_pas"
        v-model="password"
        :type="isOpen ? 'text' : 'password'"
        placeholder="请填写密码"
        :rules="[{ required: true }]"
      >
        <img
          class="password_img"
          slot="right-icon"
          :src="
            isOpen
              ? require('@/assets/img/login/l_hide.png')
              : require('@/assets/img/login/l_show.png')
          "
          alt=""
          @click="isOpen = !isOpen"
        />
      </van-field>
      <div class="form_tab">
        <span v-show="!isCode" @click="$router.push('/forgetPas')">忘记密码</span>
        <span @click="isCode = !isCode">{{
          isCode ? "密码登录" : "验证码登录"
        }}</span>
      </div>
      <van-field name="checkbox" class="input_check">
        <template #input>
          <van-checkbox v-model="agree" shape="square">
            <template #icon="props">
              <img
                class="img-icon"
                :src="
                  props.checked
                    ? require('@/assets/img/login/l_sel.png')
                    : require('@/assets/img/login/l_unsel.png')
                "
              />
            </template>
            我已阅读并同意《<span
              style="color: #4266f5"
              @click="$router.push('/apptcp')"
              >使用协议</span
            >》和《<span
              style="color: #4266f5"
              @click="$router.push('/mPAgreement')"
              >隐私政策</span
            >》</van-checkbox
          >
        </template>
      </van-field>
      <div style="margin: 10px 0 20px">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          class="form_btn"
          >登录</van-button
        >
      </div>
      <p style="font-size: 12px; color: #666666">
        未注册的手机号验证登录后将自动注册中文知识网账号
      </p>
    </van-form>
  </div>
</template>

<script>
import { Field, Form, Button, Toast } from "vant";
export default {
  name: "login",
  components: {
    "van-form": Form,
    "van-field": Field,
    "van-button": Button,
  },
  data() {
    return {
      phone: "",
      password: "",
      code: "",
      num: 59,
      timer: null,
      agree: false,
      keyFlag: true,
      isOpen: false,
      isCode: true,
    };
  },
  mounted() {
    let bgHeight = document.body.scrollHeight + 'px'
    window.onresize = () => {
      document.getElementsByClassName('bc_box')[0].style.height = bgHeight
    }
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (!this.keyFlag) return;
      if (this.phone) {
        var regExp = new RegExp("^1[35789]\\d{9}$");
        if (regExp.test(this.phone)) {
          const res = await this.$apis.loginServe.getCode({
            phone: this.phone,
            adapter: "login",
          });
          if (res.resultCode == "200") {
            Toast("获取成功");
            this.keyFlagChange();
          } else {
            Toast("获取失败,请重新获取");
          }
        } else {
          Toast("请填写正确的手机号");
        }
      } else {
        Toast("请填写手机号");
      }
    },
    // 获取验证码时间
    keyFlagChange() {
      this.keyFlag = false;
      let timer = setInterval(() => {
        if (this.num <= 0) {
          clearInterval(timer);
          this.keyFlag = true;
          this.num = 59;
        } else {
          this.num = --this.num;
        }
      }, 1000);
    },

    // 登录提交表单
    async onSubmit() {
      if (this.agree) {
        const telRegExp = new RegExp("^1[35789]\\d{9}$");
        const pasRegExp = new RegExp(
          "^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$"
        );
        if (!telRegExp.test(this.phone)) {
          Toast("请填写正确的手机号");
        } else if (!this.isCode && !pasRegExp.test(this.password)) {
          Toast("请填写6-16位含字母数字密码");
        } else {
          let obj = {
            requestType: 'MOBILE'
          };
          obj.username = this.phone
          if (this.isCode) {
            obj.validateCode = this.code;
          } else {
            obj.password = this.password;
          }
          let res = await this.$apis.loginServe.login(obj);
          if (res.resultCode !== "200") {
            Toast(res.resultDesc);
            return;
          }
          sessionStorage.setItem("token", res.data.token);
          window.history.go(-1);
          Toast("登录成功");
        }
      } else {
        Toast("请同意使用协议和隐私政策");
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.bc_box {
  padding: 76px 35px 0;
  width: 100%;
  height: 100vh;
  background: url(~@/assets/img/login/l_bg.png) no-repeat;
  background-size: 100% 100%;
}
.hello_img {
  margin-bottom: 10px;
  width: 84px;
  height: 24px;
}
.login_title {
  font-size: 23px;
  font-weight: 700;
  color: #2143af;
}
.login_form {
  margin-top: 10px;
  .van-field {
    padding: 24px 0 11px;
    // border-bottom: 1px solid #BFBFBF;
  }
  .van-cell::after {
    right: 0;
    left: 0;
    border-bottom: 1px solid #bfbfbf;
    opacity: 0.75;
  }
  .input_tel {
    &::v-deep .van-field__left-icon {
      margin-right: 16px;
      padding: 0 16px 0 7px;
      border-right: 1px solid #bfbfbf;
      .tel_code {
        font-size: 16px;
        color: #536dfe;
      }
      .fontColor {
        color: #999;
      }
    }
  }
  .input_code {
    .tel_code {
      font-size: 14px;
      color: #284fce;
    }
  }
  .input_pas {
    .password_img {
      width: 16px;
      height: 12px;
    }
  }
  .form_tab {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    color: #3650e9;
  }
  .input_check {
    margin-top: 36px;
    background-color: unset;
    &::after {
      content: none !important;
    }
    .img-icon {
      width: 13px;
      height: 13px;
    }
  }
  .form_btn {
    height: 40px;
    background: linear-gradient(0deg, #6883ff 0%, #536dfe 100%);
    .van-button__text {
      font-size: 19px;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: 5px;
    }
  }
}
</style>